import { motion } from 'motion/react';

type PulsingTextProps = {
  text?: string;
};

export const PulsingText = ({ text = '' }: PulsingTextProps) => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {[...text].map((char, index) => (
        <motion.span
          key={index}
          animate={{
            color: ['#9CA3AF', '#FFFFFF', '#9CA3AF'],
            opacity: [0.7, 1, 0.7],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            delay: index * 0.05,
            ease: 'easeInOut',
          }}
        >
          {char}
        </motion.span>
      ))}
    </motion.div>
  );
};
